<template>
  <div
    class="bind_item"
    :class="{ our_sim: item.simcard_profile && item.simcard_profile !== null }"
  >
    <div class="filter checkbox">
      <div class="active">
        <div class="info">
          {{ this.translate("device.simcard_binding.active") }}
        </div>
        <label class="switch" @click.prevent="item.status = !item.status">
          <input type="checkbox" v-model="item.status" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="filter checkbox">
      <div class="remote_sim">
        <div class="info">
          Remote SIM
        </div>
        <label class="switch no-user-access">
          <input type="checkbox" v-model="item.is_remote_sim"/>
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="bind_info">
      <div class="info_item slot">
        <fg-input
          v-model="item.slot"
          type="text"
          label="Slot"
          placeholder="Slot"
          @keydown="restrict_chars($event)"
        />
      </div>

      <div class="info_item slot">
        <fg-input
            v-model="slot"
            type="text"
            label="Current slot"
            placeholder="Current slot"
            :readonly="true"
        />
      </div>

      <div class="info_item mno">
        <fg-input
          v-model="item.mno"
          type="text"
          label="MNO"
          placeholder="MNO"
          :readonly="true"
        />
      </div>

      <div class="info_item imsi" v-show="!item.is_remote_sim">
        <fg-input
          v-model="item.imsi"
          type="text"
          label="imsi"
          placeholder="imsi"
          @keydown="restrict_chars($event)"
          :readonly="!item.new"
        />
      </div>
      <div class="info_item iccid" v-show="!item.is_remote_sim">
        <fg-input
          v-model="item.iccid"
          type="text"
          label="iccid"
          placeholder="iccid"
          @keydown="restrict_chars($event)"
          :readonly="!item.new"
        />
      </div>
    </div>

    <div class="bind_delete">
      <span v-if="item.new" class="mdi mdi-check" v-show="!item.is_remote_sim" @click="check_simcard()" />
      <span class="mdi mdi-delete" @click="delete_bind()" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BindItem",
  props: ["item", "item_key", "for_current_slot"],

  data() {
    return {
      slot: "",
      temp_sim_id: null
    };
  },
  created() {
    for (let i in this.for_current_slot) {
      if (this.for_current_slot[i].imsi === this.item.imsi) {
        this.slot = this.for_current_slot[i].slot;
      }
    }
  },
  updated() {},
  watch: {
    "item.is_remote_sim":{
      deep: true,
      handler(){
        if (this.item.is_remote_sim){
          this.temp_sim_id = this.item.simcard_id
          this.item.simcard_id = 0
        }else{
          if (this.temp_sim_id) this.item.simcard_id = this.temp_sim_id
        }
      }
    }
  },
  methods: {
    delete_bind() {
      this.$emit("delete_bind", this.item_key);
    },
    check_simcard() {
      if (this.item.imsi || this.item.iccid) {
        let params = {
          imsi: this.item.imsi.trim(),
          iccid: this.item.iccid.trim(),
        };
        this.$http.v1.checkSimcardForSimcardBinding(params, (response) => {
          this.item = Object.assign(this.item, response.data);
        });
      } else {
        this.global_notify("danger", "Imsi or iccid not filled");
      }
    },
  },
};
</script>

<style lang="scss">
.bind_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  color: #66615b;
  font-weight: bold;
  text-align: left;
  font-size: 10px;
  padding: 10px;
  background: #f8f8f8;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  &.our_sim {
    background-color: #41b88330;
  }

  .filter{
    &.checkbox {
      min-width: inherit;
      margin-bottom: 0;
    }
    .active,
    .remote_sim{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-direction: column;
      .info{
        text-align: center;
      }
    }
  }

  .bind_info {
    width: 100%;
    margin: 0 10px;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    .info_item {
      margin: 0 5px;
      .form-group {
        margin: 0;
        .form-control {
          padding: 10px;
        }
      }
      &.slot {
        flex: 1;
      }
      &.mno {
        flex: 3;
      }
      &.imsi {
        flex: 5;
      }
      &.iccid {
        flex: 5;
      }
    }
    p {
      margin: 0;
    }
  }
  .bind_delete {
    width: 4%;
    span {
      font-size: 25px;
    }
  }
}

@media (max-width: 700px) {
  .notification_triggers {
    .trigger {
      flex-wrap: wrap;
      .select {
        width: 100%;
        margin-bottom: 20px;
      }
      .params {
        width: 100%;
        margin-bottom: 20px;
      }
      .timer {
        width: 100%;
        margin-bottom: 20px;
      }
      .delete {
        display: flex;
        justify-content: center;
        width: 100%;
      }
    }
  }
}
</style>
